import { Component } from '@angular/core';
import { GetCustGrp2Params, SubmitCustGrp2Event } from '../cust-grp2.component';
import { StateService } from '@app/core/services/state.service';

@Component({
    selector: 'tt-cust-grp2-view',
    templateUrl: './cust-grp2-view.component.html',
    styleUrls: ['./cust-grp2-view.component.css'],
})
export class CustGrp2ViewComponent {
    public params: GetCustGrp2Params;

    constructor(public state: StateService) {
        this.params = state.getStateParams() as unknown as GetCustGrp2Params;
    }

    public onSubmit(_: SubmitCustGrp2Event) {
        this.state.back();
    }
}
